<template>
  
    <div class="modal warning fade" :class="{ 'is-open': open }" style="" >
      <div class="modal-dialog" style="top:30%; "  >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">即將離開本頁面</h3>
          </div>
          <div class="modal-body">
            <br />
            <span class="text-style" v-html="message"></span>
          </div>
          <div class="modal-footer">
          <div class="text-right">
            <a @click="doCancel()" class="btn btn-default">{{ cancelText }}</a>
            <a @click="doSubmit()" class="btn btn-primary">{{ submitText }}</a>
          </div>
        </div>
        </div>
      </div>
    </div>
  
</template>

<script>
export default {
  name: "leavePageWarningModal",
  data() {
    return {};
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      required: true
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    submitText: {
      type: String,
      default: "確定",
    },
  },
  methods: {
    doCancel(){
      this.$emit("close");
    },
    doSubmit(){
      this.$emit("submit");
    }
  },
};
</script>

<style scoped>
.text-style {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight:bolder;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #323a45;
}

</style>